function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M148.864 91.81s-4.007 8.346-10.615 9.558c-6.608 1.212-13.315-5.169-13.315-5.169s4.175-7.425 10.783-8.637c6.608-1.212 13.147 4.248 13.147 4.248zm-42.474 4.822s-6.993 6.065-13.539 4.55c-6.545-1.514-10.164-10.035-10.164-10.035s6.783-5.154 13.329-3.64c6.545 1.515 10.374 9.125 10.374 9.125z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M86.672 81.68a12.232 12.232 0 0116.291.903l.16.16h-17.78l1.329-1.063zm43.043 0a12.233 12.233 0 0116.291.903l.16.16h-17.779l1.328-1.063zm-43.17 9.4a4.679 4.679 0 119.116 2.109 4.679 4.679 0 01-9.116-2.11zm41.901 3.524a4.678 4.678 0 119.203-1.688 4.678 4.678 0 11-9.203 1.688z",
  fill: "#212121"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M131.815 122.159c0 4.594-7.122 10.813-15.907 10.813-8.786 0-15.908-6.219-15.908-10.813 0 0 7.122-4.159 15.908-4.159 8.785 0 15.907 4.159 15.907 4.159z",
  fill: "#ED313C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.148 131.912c5.684-1.973 9.667-6.318 9.667-9.753 0 0-7.122-4.159-15.907-4.159-8.786 0-15.908 4.159-15.908 4.159 0 3.435 3.983 7.78 9.667 9.753a6.552 6.552 0 0112.481 0z",
  fill: "#5F3460"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.036 120.409a3.743 3.743 0 01-3.705 3.205h-16.843a3.744 3.744 0 01-3.705-3.206c2.918-1.136 7.267-2.408 12.125-2.408 4.86 0 9.21 1.272 12.128 2.409z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.16 85.635c7.155.614 11.564 7.478 12.84 10.365l-1.712.756c-1.246-2.819-5.258-8.74-11.288-9.256-5.463-.468-9.222 2.004-11.5 3.5-.292.191-.567.372-.829.535l-.99-1.587c.239-.15.499-.321.782-.508 2.296-1.515 6.56-4.33 12.697-3.805zm41.556-.032c-7.176.283-11.809 7.072-13.216 9.897l1.675.834c1.375-2.759 5.567-8.623 11.615-8.861 5.478-.217 9.137 2.395 11.344 3.995.283.204.549.397.803.572L150 90.5c-.232-.16-.484-.344-.758-.543-2.224-1.619-6.372-4.597-12.526-4.354z",
  fill: "#212121"
});

function SvgFace0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "static/media/face-0.b297b139.svg";
export { SvgFace0 as ReactComponent };